<template>
  <div class="dashboard secondary">
    <dashboard-app-nav
      :on-sign-out="onSignOut"
      :on-drawer-change="onDrawerChange"
      :account="account"
      :on-drawer-toggle="onDrawerToggle"
      :menu="menu"
      :permission="account && account.role && account.role[0].name"
      :on-logo-click="onLogoClick"
    >
      <v-toolbar-items>
        <dashboard-notifications
          :account="account"
          :is-admin="isAdmin"
          :has-permission="hasPermission"
          :notifications="notifications"
          :read-and-go="readAndGo"
          :infinite-handler="findNotificacoes"
        />
      </v-toolbar-items>
    </dashboard-app-nav>
    <v-content id="content">
      <router-view />
    </v-content>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import dashboardNotifications from '@/components/dashboard-notifications.vue';
import dashboardAppNav from '@/components/dashboard-app-nav.vue';

export default {
  name: 'Dashboard',
  components: {
    dashboardNotifications,
    dashboardAppNav,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.afterRouteUpdate();
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.afterRouteUpdate();
    next();
  },
  computed: {
    ...mapGetters('views/dashboard', [
      'drawer',
      'menu',
      'account',
      'logo',
      'hasPermission',
      'isAdmin',
      'notifications',
    ]),
  },
  methods: mapActions('views/dashboard', [
    'onDrawerChange',
    'onDrawerToggle',
    'onSignOut',
    'afterRouteUpdate',
    'readAndGo',
    'findNotificacoes',
    'onLogoClick',
  ]),
};
</script>
<style>
.v-icon.v-icon {
  font-size: 16px;
  width: 24px;
}
.v-input--selection-controls__ripple {
  height: 30px;
  width: 30px;
  left: -10px;
  top: calc(50% - 22px);
}
.highlight {
  background: #fcbc88;
}
</style>
